import styled from "styled-components";
import Section from "../Section";

const PrivacyContainer = styled.div`
  max-width: 860px;
  width: 100%;
  margin: 0 auto;
  padding: 2.2rem;
  border: 1px solid var(--line);
  border-radius: 1.4rem;
  background: var(--bg-panel);
  text-align: left;

  h1 {
    font-size: clamp(2rem, 5vw, 3rem);
    margin: 0 0 1.2rem;
    text-align: center;
    font-weight: 600;
    letter-spacing: 0.02em;

    @media (max-width: 768px) {
      font-size: 2.4rem;
    }

    @media (max-width: 480px) {
      font-size: 2rem;
    }
  }

  h2 {
    margin-top: 2rem;
    margin-bottom: 0.6rem;
    font-size: 1.3rem;
    color: var(--accent);
    font-weight: 500;
    letter-spacing: 0.02em;
  }

  p {
    font-size: 1rem;
    line-height: 1.75;
    opacity: 0.95;
    margin-bottom: 0.9rem;
    color: var(--text-muted);
  }

  ul {
    margin: 0.8rem 0 1.2rem 1.25rem;
    color: var(--text-muted);

    li {
      margin-bottom: 0.45rem;
      line-height: 1.6;
    }
  }

  a {
    color: var(--accent-soft);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .updated {
    text-align: center;
    font-size: 0.9rem;
    opacity: 0.7;
    margin-bottom: 1.8rem;
  }
`;

export default function PrivacyPolicy() {
  return (
    <Section bg="#0d0d14" color="#f0eafc">
      <PrivacyContainer>
        <h1>privacy policy</h1>

        <p className="updated">last updated: august 2, 2026</p>

        <p>
          this privacy policy explains how our mobile application collects,
          uses, and protects information when you use our application.
        </p>

        <h2>information we collect</h2>

        <p>
          our application may collect certain information automatically,
          including:
        </p>

        <ul>
          <li>device information</li>
          <li>operating system information</li>
          <li>advertising identifiers</li>
          <li>crash and performance data</li>
          <li>anonymous usage statistics</li>
        </ul>

        <p>
          we do not collect personally identifiable information such as your
          name, email address, phone number, or exact location unless you
          voluntarily provide it.
        </p>

        <h2>advertising</h2>

        <p>
          our application may use third-party advertising services such as
          google admob to display advertisements.
        </p>

        <p>
          these services may collect information about your device and usage
          patterns to provide relevant advertisements.
        </p>

        <h2>third-party services</h2>

        <p>
          third-party services used by the application may have their own
          privacy policies. we recommend reviewing their policies for more
          information.
        </p>

        <h2>data security</h2>

        <p>
          we take reasonable measures to protect information collected through
          the application. However, no electronic storage method is completely
          secure.
        </p>

        <h2>children's privacy</h2>

        <p>
          our application does not knowingly collect personal information from
          children.
        </p>

        <h2>changes to this privacy policy</h2>

        <p>
          we may update this privacy policy from time to time. changes will be
          published on this page with an updated date.
        </p>

        <h2>contact</h2>

        <p>if you have questions about this privacy policy, contact us at:</p>

        <p>emirmelikakts@gmail.com</p>
      </PrivacyContainer>
    </Section>
  );
}
